// getters
const academicStudents = state => state.academicStudents

export default {
    academicStudents
}



// WEBPACK FOOTER //
// ./src/store/modules/academic/student/getters.js